import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiPopoverModule } from '@cigna/shared/angular/popover-ui';
import { FormsModule } from '@angular/forms';
import { PdlViewerSharedUtilModule } from '@cigna/pdl-viewer/shared/util';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { TranslateModule } from '@ngx-translate/core';
import { SearchBoxComponent } from './search-box/search-box.component';
import { NotesDefinitionComponent } from './notes-definition/notes-definition.component';
import { AdditionalDrugInfoComponent } from './additional-drug-info/additional-drug-info.component';
import { DrugSearchResultsTableComponent } from './drug-search-results-table/drug-search-results-table.component';
import { PrintPdlComponent } from './print-pdl/print-pdl.component';
import { UiResponsiveModule } from '@cigna/shared/angular/responsive-ui';
import { UiInputModule } from '@cigna/shared/angular/input-ui';

const DECLARATIONS = [
  SearchBoxComponent,
  DrugSearchResultsTableComponent,
  NotesDefinitionComponent,
  AdditionalDrugInfoComponent,
  PrintPdlComponent,
];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiPopoverModule,
    PdlViewerSharedUtilModule,
    UiProgressModule,
    TranslateModule,
    UiIconModule,
    UiButtonModule,
    UiResponsiveModule,
    UiInputModule,
  ],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class PdlViewerDrugSearchUiModule {}
